import React from 'react';
import { Tag } from 'antd';
import { ENotificationTypes, NotificationTypes } from '../INotification';

export interface ITextResources {
  error: string;
  warning: string;
  maintenance: string;
  news: string;
}

interface IProps {
  type: ENotificationTypes;
  textResources?: ITextResources;
}

function getLabel(
  type: ENotificationTypes,
  textResources?: ITextResources
): string {
  let translatedLabel: string = type.toString();
  if (textResources && translatedLabel.toLocaleLowerCase() in textResources) {
    translatedLabel = (textResources as any)[
      translatedLabel.toLocaleLowerCase()
    ];
  }
  return translatedLabel;
}

function getBackgroundColor(type: ENotificationTypes): string {
  let bgColor: string;
  switch (type) {
    case NotificationTypes.ERROR:
      bgColor = 'error';
      break;
    case NotificationTypes.WARNING:
      bgColor = 'warning';
      break;
    case NotificationTypes.MAINTENANCE:
      bgColor = 'processing';
      break;
    case NotificationTypes.NEWS:
      bgColor = 'success';
      break;
    default:
      bgColor = '#0B4566';
      break;
  }
  return bgColor;
}

const MikeNotificationChip = (props: IProps) => {
  const { type, textResources } = props;

  return (
    <Tag color={getBackgroundColor(type)}>{getLabel(type, textResources)}</Tag>
  );
}; // <Chip classes={classes} label={getLabel(type, textResources)} size="small" />;

export default React.memo(MikeNotificationChip);
